import { keyframes } from '@emotion/react';

const rotateAnimation = keyframes({
    to: {
        transform: 'rotate(360deg)',
    },
});

export const styles = {
    rotation: {
        animation: `${rotateAnimation} 1s linear infinite`,
    },
};
